export const KEYS = {
  TAG_BLACKLIST: 'tag_blacklist',
  USERNAME_BLACKLIST: 'username_blacklist',
  SHOW_COMPLETED: 'show_completed',
}
